import * as React from 'react';
import { connect } from 'react-redux';
import { PORTABLE_POSSESSIONS_RISK, LEGAL_STUFF } from '../../../routes/routes';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import { getMobilePaymentSchedule, addBankingDetailsToQuote, getLegalQuestions, addBankingDetailsNamToQuote } from '../../../actions/salesActions';

class SetupDebitOrderDetails extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            isConfirm: true,
            date: false,
            stateDetails: []
        };
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleAcceptBankingDetails = this.handleAcceptBankingDetails.bind(this);
        this.checkPortableCartValue = this.checkPortableCartValue.bind(this);
        this.saveNewPayment = this.saveNewPayment.bind(this);
    }

    async handleClick() {
        this.props.dispatchSetPortablePossessionsClaimHistory(this.state.selectedClaimHistory);
        this.props.dispatchAddPortablePossessionsToQuote();
    }

    async handleRedirect(nextPage: string) {
        await this.saveNewPayment();
        if (this.props.sales.bankError) {
            await this.setState({ isConfirm: false });
        } else {
            await this.setState({ isConfirm: true });
        }
    }

    async handleAcceptBankingDetails(e: any) {
        if (this.props.profile.countryId === 157) {
            this.props.dispatchSaveNamBankingDetailsToQuote()
        }
        else {
            this.props.dispatchSaveBankingDetailsToQuote();
        }
        await this.props.dispatchGetLegalQuestions();
        this.props.dispatchAcceptBankingDetails();
    }

    async componentDidMount() {
        var debitOrderDate = this.props.sales.debitOrderDate.id
        var inceptionDate = this.props.sales.inceptionDate?.split('T')[0]
        var inceptionDateCompare = this.props.sales.inceptionDate?.split('T')[0].substring(8);

        if (debitOrderDate != null && inceptionDate != null) {
            this.setState({ date: (debitOrderDate < inceptionDateCompare) });
        }
    }

    checkPortableCartValue() {
        var cartItems = this.props.cart.products;
        var totalReplacementValue = 0;
        for (var i = 0; i < cartItems.length; i++) {
            totalReplacementValue += cartItems[i].replacementValue
        }
        if (totalReplacementValue > 300000) {
            this.props.dispatchShowReplacementValueCallBack()
            return false;
        }
        return true;
    }

    async saveNewPayment() {
        await this.props.dispatchGetLegalQuestions();
        if (this.props.cart.products.length === 0) {
            this.props.dispatchShowErrorModal("No items in cart")
        } else if (this.checkPortableCartValue()) {
            if (this.state.selectedBank.id === undefined) {
                await this.setState({ bankError: true });
            }
            else {
                await this.setState({ bankError: false });
            }
            if (this.state.selectedBranch.id === undefined) {
                await this.setState({ branchError: true });
            } else {
                await this.setState({ branchError: false });
            }
            if (this.state.selectedAccountType.id === undefined) {
                await this.setState({ accountTypeError: true });
            } else {
                await this.setState({ accountTypeError: false });
            }
            if (this.state.selectedDebitDay.id === undefined) {
                await this.setState({ debitDayError: true });
            } else {
                await this.setState({ debitDayError: false });
            }
            if (this.state.accountNumber === "") {
                await this.setState({ accountNumberError: true });
            } else {
                await this.setState({ accountNumberError: false });
            }
            if (!this.state.accountNumberError && !this.state.debitDayError && !this.state.accountTypeError && !this.state.branchError && !this.state.bankError) {
                await this.props.dispatchAddBankingDetailsToQuote(this.state);
            }
        }
    }

    async handleBack() {
        await this.setState({ isConfirm: false });
    }

    public render() {
        let selectedBank = this.props.sales.bankName;
        let selectAccountNumber = this.props.sales.accountNumber;
        let stringDate = this.props.sales.firstPremiumDate ? this.props.sales.firstPremiumDate : null;
        var collectionDate = stringDate?.split('T')[0];
        var inceptionDate = this.props.sales.inceptionDate?.split('T')[0]

        return (
            <div className="row noma confirm-banking-details">
                <div className="col-12 mb-15px nopa">
                    <p className="text-red font-size-16px line-height-normal mb-0px"><b>You’ll soon be under the king’s protection</b></p>
                </div>
                <div className="col-12 nopa">
                    {/*set up debit order*/}
                    {(!this.props.profile.isLinked) &&
                        <p className="mb-0px font-weight-normal">
                            <b>{this.props.sales.name} {this.props.sales.surname}</b>, to confirm the details of your debit order, the following amounts will be debited from your account:
                            <ul className="confirm-bullets">
                                <li>A once-off pro rata of <b>{this.props.profile.currencySymbol}{this.props.sales.firstPremium}</b> (on <b>{collectionDate}</b>).</li>
                                {this.state.date && <li>Your premium of <b>{this.props.profile.currencySymbol}{this.props.sales.carPremium}</b> (on <b>{collectionDate}</b>, and thereafter the <b>{this.props.sales.debitOrderDate.description?.replace(' of every month', '')}</b> of every month).</li>}
                            </ul>

                            Then on the <b>{this.props.sales.debitOrderDate.description.replace(' of every month', '')}</b> of each month, your total monthly premium of <b>{this.props.profile.currencySymbol}{this.props.sales.carPremium}</b> will be deducted from your <b>{selectedBank}</b> account <b>{selectAccountNumber}</b> registered to <b>{this.props.sales.idNumber}</b>, and will reflect as ‘King Price’ on your bank statement.
                            <br /><br />
                            If your debit order date falls on a Sunday or a public holiday, collection will be on the next ordinary business day.
                            <br /><br />
                            By tapping on <b>‘Pay’</b> you hereby confirm that:
                            <ul>
                                <li>The specified account belongs to you.</li>
                                <li>You’re happy for your cover to start from <b>{inceptionDate}</b>.</li>
                                <li>King Price is authorised to deduct the amounts stated above from your account.</li>
                            </ul>
                        </p>
                    }
                    <hr className="banking-hr-2px mt-21px mb-15px d-block d-md-block d-lg-none" />
                </div>

                <div className="col-12 nopa mt-30px mobile-mt-0px">
                    <div className="text-center d-none d-md-none d-lg-block">
                        <button className="btn btn-solid-green" id="btnPay" onClick={this.handleAcceptBankingDetails}>Pay</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchGetLegalQuestions: () => dispatch(getLegalQuestions()),
        dispatchSaveBankingDetailsToQuote: (state) => dispatch(addBankingDetailsToQuote()),
        dispatchSaveNamBankingDetailsToQuote: (state) => dispatch(addBankingDetailsNamToQuote()),
        dispatchAcceptBankingDetails: (state) => dispatch(navigateTo(LEGAL_STUFF)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SetupDebitOrderDetails);